import React, { forwardRef, useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import SubUserRolesDialog from './SubUserRolesDialog';

const EditSubUserAction = forwardRef((props: any, ref: any) => {
  const { tenantId, record } = props;
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MenuItem ref={ref} onClick={handleOpen}>
        Edit
      </MenuItem>

      {open && (
        <SubUserRolesDialog
          open={open}
          onClose={handleClose}
          initialValues={record}
          tenantId={tenantId}
        />
      )}
    </>
  );
});

export default EditSubUserAction;
